/*
 * @Author: Teemo Ding
 * @Date: 2021-07-09 15:15:43
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-13 11:20:57
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/tax/index.ts
 */
import { get, post, remove } from '@/src/tools/server';

export const initStoreTaxes = (startIndex, batchSize) => {
  return post<any>(
    `/portal/setting/store/taxes/${startIndex}/${batchSize}`,
    {},
    {},
  );
};

export const searchStoreTaxes = (startIndex, batchSize, body) => {
  return post<any>(
    `/portal/setting/store/taxes/search/${startIndex}/${batchSize}`,
    body || {},
    {},
  );
};

export const getTaxDetail = (params) => {
  return get<any>(`/portal/setting/store/tax`, {
    params: params,
  });
};
export const saveTaxDetail = (body) => {
  return post<any>(`/portal/setting/store/tax`, body, {});
};
export const deleteTax = (taxUuid) => {
  return remove<any>(`/portal/setting/store/tax/${taxUuid}`, {});
};
